var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"imgBox min-w-1400"},[_vm._m(0),_c('div',{staticClass:"imgBox2 min-w-1400"},[_c('div',{staticClass:"img2 max-w-1400"},[_c('h1',[_vm._v("Acuerdo de privacidad")]),_c('div',{staticClass:"textBox",staticStyle:{"white-space":"pre-wrap"}},[_vm._v(_vm._s(_vm.text))])])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"imgBox1 min-w-1400"},[_c('div',{staticClass:"img1 max-w-1400"})])
}]

export { render, staticRenderFns }